import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import integrationIcon from '../assets/integration.svg';
import { useParams } from "react-router-dom";
import _ from 'lodash';
import { Auth } from '../utils/amplifyWrapper';
import * as Sentry from '@sentry/react';
import { useOrganisation } from '../http-hooks/organisation/useOrganisation';
import { useIntegrations } from '../http-hooks/integration/useIntegration';
import { Card } from '../components/ui/bootstrap';
import { ArrowRight } from 'lucide-react';
import CardWrapSkeleton from '../components/skeletons/pages/CardWrapSkeleton';
import CreateProjectModal from '../components/CreateProjectModal';
import { useGlobalStore } from '../zustand-store/useGlobalStore';

function Integration(){

    const history = useHistory();
    const [ userAttr, setUserAttr ] = useState(null);
    const { org_id } = useParams();
    const toggleCreateProjectModal = useGlobalStore((state) => state.toggleCreateProjectModal);

    // ✨ Migrated to React Query
    const { data: org, isLoading: isLoadingOrg } = useOrganisation({ org_id });
    const { data: integrations = [], isLoading: isLoadingIntegrations } = useIntegrations({ org_id });
    
    const isLoading = isLoadingOrg || isLoadingIntegrations;
    const sortedIntegrations = _.sortBy(integrations, [(integration) => new Date(integration.created_at)]);

    const cardStyle = {
        width: 256,
        minHeight: 200,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
    };

    const Integrations = () => (
        <React.Fragment>
            <div className="row my-5">
                <div className="col-12">
                    <h3>Welcome {(userAttr && userAttr.hasOwnProperty("name") ? userAttr.name : ' to Listen2It')}!</h3>
                    <p>Please choose a project below.</p>
                </div>
            </div>
            <div className="d-flex flex-wrap gap-3">
                {sortedIntegrations.map((integration) => (
                    <Card
                        key={integration.SK}
                        className="p-4"
                        style={cardStyle}
                        shadow
                    >
                        <div className="flex-grow-1">
                            <div className="d-flex align-items-center mb-2">
                                <img src={integrationIcon} alt="integration icon" className="me-2" />
                                <span
                                    className="fw-semibold text-body-emphasis text-truncate"
                                    style={{ maxWidth: '80%' }}
                                >
                                    {integration.integration_name}
                                </span>
                            </div>
                            <p
                                className="text-secondary mb-0"
                                style={{
                                    fontSize: 14,
                                    display: '-webkit-box',
                                    WebkitLineClamp: 5,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                }}
                            >
                                {integration.description}
                            </p>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                            <button
                                type="button"
                                className="btn btn-sm d-inline-flex align-items-center gap-1"
                                style={{
                                    background: 'rgba(var(--bs-primary-rgb),0.08)',
                                    border: '1px solid rgba(var(--bs-primary-rgb),0.2)',
                                    color: 'var(--bs-primary)',
                                    borderRadius: 50,
                                    fontSize: 13,
                                    padding: '4px 14px',
                                }}
                                onClick={() => history.push(`/organisation/${org_id}/integration/${integration.SK.split('#')[1]}/content`)}
                            >
                                Open <ArrowRight size={13} />
                            </button>
                        </div>
                    </Card>
                ))}
                <Card
                    className="p-4 d-flex flex-column align-items-center justify-content-center"
                    style={{ ...cardStyle, cursor: 'pointer' }}
                    onClick={() => toggleCreateProjectModal(true)}
                >
                    <svg fill="none" stroke="var(--bs-secondary-color)" height={48} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="fw-semibold text-body-emphasis mb-0 mt-2">New Project</p>
                </Card>
            </div>
        </React.Fragment>
    );

    const EmptyState = () => (
        <div className="col-md-6 py-5">
            <p className="fw-bold text-body-emphasis mb-4" style={{ fontSize: 22 }}>Welcome {(userAttr && userAttr.hasOwnProperty("name") ? userAttr.name : ' to Listen2It')}!</p>
            <p className="text-secondary mt-4">Get started by creating your first project to sync your website or app content with Listen2It. You can create multiple projects for different Websites and APPs that you manage.</p>
            <p className="text-secondary">For more information, we recommend going through our Getting Started Guide.</p>
            <button type="button" className="btn btn-primary" onClick={() => toggleCreateProjectModal(true)}>Create a project</button>
        </div>
    );

    const ChoosePlan = () => (
        <div className="col-md-6 py-5">
            <p className="fw-bold text-body-emphasis mb-4" style={{ fontSize: 22 }}>Welcome {(userAttr && userAttr.hasOwnProperty("name") ? userAttr.name : ' to Listen2It')}!</p>
            <p className="text-secondary mt-4">Seems like you have not subscribed to any plan.</p>
            <button type="button" className="btn btn-primary" onClick={() => history.push(`/organisation/${org_id}/plans`)}>Choose Plan</button>
        </div>
    );

    useEffect(()=>{

        Auth.currentAuthenticatedUser({
            bypassCache: true
        }).then(user => { setUserAttr(user.attributes); })
            .catch(err => Sentry.captureException(err));

        // ✨ org and integrations now fetched via React Query hooks

    },[]);

    return(
        <React.Fragment>
            <CreateProjectModal />
            <div className="container-fluid">
                <div className="container">
                    {
                        (isLoading || !org)?
                        (
                            <CardWrapSkeleton cardHeight={200} />
                        )
                        :
                        (
                            (org.plan_id)?
                                (
                                    (integrations.length > 0)
                                        ?
                                        (
                                            <Integrations />
                                        )
                                        :
                                        (
                                            <EmptyState />
                                        )
                                )
                                :
                                (
                                    <ChoosePlan />
                                )
                        )
                    }
                </div>
            </div>
        </React.Fragment>
    );
}


export default Integration;
